import { html } from "src/components/HtmlViewer/utils";
import * as GQL from "src/types/graphql";

export const FORM_STARTED = {
  type: GQL.message_template_type_enum.FormStarted,
  emailSubject:
    "You started your {{organization.name}} application! / ¡Ha comenzado su aplicación {{organization.name}}!",
  emailHtml: html`
    <p>
      Dear {{parent.name}},<br />
      <br />
      Thank you for starting your {{organization.name}} form for
      {{student.name}} for the {{enrollmentPeriod.name}}!<br />
      <br />
      Complete your form here: {{applyUrl}}<br />
      <br />
      If you need help, please contact {{organization.name}}.<br />
      <br />
      -{{organization.name}} Team<br />
    </p>
    <p>_____________________________________________</p>
    <p>
      Estimado/a {{parent.name}},<br />
      <br />
      ¡Gracias por comenzar su aplicación {{organization.name}} para
      {{student.name}} para el {{enrollmentPeriod.name}}!<br />
      <br />
      Finalice su aplicación aquí: {{applyUrl}}<br />
      <br />
      Si necesita ayuda, por favor contacte a {{organization.name}}.<br />
      <br />
      -Equipo de {{organization.name}}<br />
    </p>
  `,
  emailText: `Dear {{parent.name}},

Thank you for starting your {{organization.name}} form for {{student.name}} for the {{enrollmentPeriod.name}}!

Complete your form here: {{applyUrl}}

If you need help, please contact {{organization.name}}.

-{{organization.name}} Team

_____________________________________________

Estimado/a {{parent.name}},

¡Gracias por comenzar su aplicación {{organization.name}} para {{student.name}} para el {{enrollmentPeriod.name}}!

Finalice su aplicación aquí: {{applyUrl}}

Si necesita ayuda, por favor contacte a {{organization.name}}.

-Equipo de {{organization.name}}`,
  sms: `You've started your {{organization.name}} application! Complete your form here: {{applyUrl}} / ¡Ha comenzado su aplicación {{organization.name}}! Finalice su aplicación aquí: {{applyUrl}}`,
};
